import { render } from "./SignupTrigger.vue?vue&type=template&id=6b60b210"
import script from "./SignupTrigger.vue?vue&type=script&lang=js"
export * from "./SignupTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__